import * as homeworksActions from './actions'
import { Record } from '../transit'

const State = Record({
  all: [],
  currentHomework: null,
  loadedHomeworks: false,
  homeworkLoadError: false,
}, 'homeworks')

const homeworksReducer = (state = new State(), action) => {
  switch (action.type) {
    case homeworksActions.HOMEWORK_LOAD_START: {
      return state.set('homeworkLoadError', false)
    }
    case homeworksActions.HOMEWORK_SAVE_SUCCESS:
    case homeworksActions.HOMEWORK_ADD_SUCCESS: {
      const newHomework = action.payload.data
      return state.set('all', state.get('all').push(newHomework))
                  .set('currentHomework', newHomework)
    }
    case homeworksActions.HOMEWORK_EDIT_SUCCESS: {
      const editedHomework = action.payload.data
      let homeworks = state.get('all')
        .filter(hw => hw.id !== editedHomework.id)
      homeworks = homeworks.push(editedHomework)
      return state.set('all', homeworks)
    }
    case homeworksActions.HOMEWORK_DELETE_SUCCESS: {
      const deletedID = action.payload.data._id
      const homeworks = state.get('all')
                                .filter(hw => hw.id !== deletedID)
      return state.set('all', homeworks)
    }
    case homeworksActions.HOMEWORK_CLEAR_DETAIL: {
      return state.set('currentHomework', null)
    }
    case homeworksActions.HOMEWORKS_CLEAR: {
      return state.set('all', [])
    }
    case homeworksActions.HOMEWORKS_LOAD_SUCCESS: {
      const data = action.payload.data
      return state.set('all', data)
                  .set('loadedHomeworks', true)
    }
    case homeworksActions.HOMEWORK_LOAD_SUCCESS: {
      const data = action.payload.data
      return state.set('currentHomework', data)
                  .set('homeworkLoadError', false)
    }
    case homeworksActions.HOMEWORK_LOAD_ERROR: {
      const data = action.payload.data
      return state.set('currentHomework', null)
                  .set('homeworkLoadError', true)
    }
    case homeworksActions.GET_PUBLIC_HOMEWORKS_SUCCESS: {
      const homeworks = action.payload.data
      return state.set('publicHomeworks', homeworks)
    }
    case homeworksActions.SET_CURRENT_HOMEWORK: {
      return state.set('currentHomework', action.payload)
    }
    default: {
      return state
    }
  }
}

export default homeworksReducer



// WEBPACK FOOTER //
// ./src/common/homeworks/reducer.js